import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Dealer} from '../../../../models/dealers/dealer.model';
import {ContractType} from '../../../../models/warranties/contract-type.model';
import {IDropdownSettings} from 'ng-multiselect-dropdown';
import {HttpService} from '../../../../services/http.service';
import {ActivatedRoute} from '@angular/router';
import {SweetUtil} from '../../../commons/sweet/sweet-util-service';
import {AdminActionPeriod} from '../../../../models/action/admin-action-period.model';
import {Market} from '../../../../models/dealers/market.enum';
import {AuthService} from "../../../../auth/auth.service";

@Component({
  selector: 'app-action-period',
  templateUrl: './action-period.component.html',
  styleUrls: ['./action-period.component.scss']
})
export class ActionPeriodComponent implements OnInit, OnDestroy {

  @ViewChild('contractType') contractType: HTMLInputElement;
  @ViewChild('contractCode') contractCode: HTMLInputElement;

  sub: any;
  market: Market;
  displayBMWi: boolean;
  vinList = '';
  dealerList: Dealer[];
  regions: string[];
  dealers: string[];
  models: string[];

  contractTypes: ContractType[] = [];
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 6,
    allowSearchFilter: true
  };

  actionPeriod: AdminActionPeriod = new AdminActionPeriod();
  discountError = '';

  constructor(private http: HttpService, private route: ActivatedRoute, private authService: AuthService) {
  }

  ngOnInit(): void {
    this.market = this.authService.market();
    this.displayBMWi = this.market === Market.BE;
    this.http.fetchActionPeriodsRegions().subscribe((res) => {
      this.regions = Object.assign([], res);
    });
    this.http.fetchActionPeriodsDealers().subscribe((res: any[]) => {
      this.dealerList = Object.assign([], res);
      this.dealers = [];
      res.forEach(r => this.dealers.push(r.dealerNumber));
    });
    this.http.fetchActionPeriodModels().subscribe((res) => {
      this.models = [];
      res.forEach(m => {
        this.models.push(m.modelCode);
      });
    });

    this.sub = this.route.params.subscribe((p) => {
      if (p.id) {
        this.http.fetchAdminActionPeriod(p.id).subscribe((promo) => {
          this.actionPeriod = Object.assign(new AdminActionPeriod(), promo);
          this.http.fetchActionPeriodContractTypes(this.actionPeriod.selectedBrand).subscribe((res) => {
            this.contractTypes = Object.assign([], res);
            this.actionPeriod.selectedContractType = this.contractTypes.find(c => c.contractType === this.actionPeriod.selectedContractType.contractType);
            this.actionPeriod.selectedVins.forEach(v => this.vinList += v + '\n');
          });
        });
      }
    });
  }

  selectAllDealersInSelectedRegions() {
    let tempDealers: Dealer[] = [];
    const tempSelected: string[] = [];
    this.actionPeriod.selectedRegions.forEach(r => {
      tempDealers = this.dealerList.filter(d => d.dealerRegion === r);
      this.actionPeriod.selectedDealers = [];
      tempDealers.forEach(t => {
        tempSelected.push(t.dealerNumber);
      });
      tempSelected.forEach(t => this.actionPeriod.selectedDealers.push(t));
    });
  }

  fetchContractTypes() {
    this.http.fetchActionPeriodContractTypes(this.actionPeriod.selectedBrand).subscribe((res) => {
      this.contractTypes = Object.assign([], res);
    });
  }

  setContractDurations() {
    this.actionPeriod.selectedContractCode = null;
  }

  saveActionPeriod() {
    if (!this.isValid()) {
      return;
    }

    if (this.vinList) {
      this.actionPeriod.selectedVins = this.vinList.split('\n');
    }

    this.http.saveActionPeriod(this.actionPeriod).subscribe((res: any) => {
      SweetUtil.showSuccess('Action Period published').then();
      this.goBack();
    });
  }

  isValid(): boolean {
    return this.actionPeriod.selectedBrand && this.actionPeriod.selectedBrand.trim().length > 0;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  goBack() {
    window.history.back();
  }

  deleteActionPeriod() {
    SweetUtil.getConfirm('Delete Action Period?', ' Are you sure you want to remove this Action Period?').then((res) => {
      if (res.value) {
        this.http.deleteActionPeriod(this.actionPeriod.id).subscribe(() => {
          this.goBack();
        });
      }
    });
  }

}
